import { Component, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'popup-advertisement',
  templateUrl: './popup-advertisement.component.html',
  styleUrls: ['./popup-advertisement.component.css']
})
export class PopupAdvertisementComponent implements OnInit {

  public title: string;
  public message: string;
  public img: string;

  constructor(protected dialogRef: NbDialogRef<PopupAdvertisementComponent>) {
    this.title = '';
    this.message = '';
    this.img = ''
  }

  ngOnInit(): void {
  }

  submit(value: string){
    this.dialogRef.close(value);
  }

}
